import store from '../../../../../../store';
import { logoutUser } from '@ameroservices-platform/attraction-frontend/app/auth/store/userSlice';

function LogoutPage() {
	store.dispatch(logoutUser());
	return 'Logging out..';
}

export default LogoutPage;
